import { render, staticRenderFns } from "./wrongQuestion.vue?vue&type=template&id=eb1e44c2&scoped=true"
import script from "./wrongQuestion.vue?vue&type=script&lang=js"
export * from "./wrongQuestion.vue?vue&type=script&lang=js"
import style0 from "./wrongQuestion.vue?vue&type=style&index=0&id=eb1e44c2&prod&lang=less&scoped=true"
import style1 from "./wrongQuestion.vue?vue&type=style&index=1&id=eb1e44c2&prod&media=print&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb1e44c2",
  null
  
)

export default component.exports